import {setDataToEdit, setEditMode, setEnabledForm, setFormInfo} from "../../../redux/actions/genericActions";
import {saveCategory, updateCategory} from "../../../redux/actions/categoryActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {FORM, INTERNATIONAL, LB_ACTIVE, LB_CODE, LB_PRIORITY} from "../../../components/i18n/i18n";
import {GenericButton} from "../../../components/buttons/customButtons";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import Separator from "../../../components/Separator";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {PH_CODE, PH_ICON, PH_NEXT_VIEW} from "../../../components/i18n/placeHolders";
import {
    FL_FATHER_CATEGORY, FL_GENERAL_CATEGORY,
    FL_ICON,
    FL_NEXT_VIEW,
    FL_SHOW_IN_HOME,
    FL_TYPE_VIEW
} from "../../../components/i18n/formLabels";
import SelectGeneric from "../../../components/select/selectGeneric";
import {typeViewProvider} from "../../../providers/typeViewProvider";
import {hotelCategoryProvider} from "../../../providers/hotelCategoryProvider";
import Switch from "react-bootstrap-switch";
import HotelCategoryLangs from "../../hotel/category/_langs";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import React from "react";


const JobHistoryForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { domainObject } = componentState?.data;

    const closeForm = () => props.onClose()

    return <Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}

            <div className={'top-right'}>
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_CLOSE}
                    icon={'fa-times'}
                    permission={'search'}
                    onClick={closeForm}
                />
            </div>
        </CardTitle>
        <CardBody className={'card-body-modal'}>
            <Row>
                <Col>
                    <FormGroup>
                        <Label>Job:</Label>
                        <Input
                            type="text"
                            name="job"
                            value={domainObject?.job}
                            readOnly={ true }
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label>Acción:</Label>
                        <Input
                            type="text"
                            name="action"
                            value={domainObject?.action}
                            readOnly={ true }
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>Fecha de registro:</Label>
                        <Input
                            type="text"
                            name="registerDate"
                            value={domainObject?.registerDate}
                            readOnly={ true }
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label>Información adicional:</Label>
                        <Input
                            type="textarea"
                            name="data"
                            value={domainObject?.data}
                            rows={9}
                            readOnly={ true }
                        />
                    </FormGroup>
                </Col>
            </Row>
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFormInfo,
    setDataToEdit,
    setEnabledForm,
    setEditMode,
    saveCategory,
    updateCategory,
})

export default connect(mapStateToProps, mapActionsToProps)(JobHistoryForm)